export default __webpack_public_path__ + "static/media/level-1.5491d2b6.png";